import React from 'react';
import styles from './ListSelect.module.scss';

const ListSelect = ({ options, selected, onChange, disabled = false }) => {
    return (
        <div className={styles.listContainer}>
            {options.map((option) => (
                <div
                    key={option.value}
                    className={`${styles.listItem} ${
                        selected === option.value ? styles.selected : ''
                    } ${disabled ? styles.disabled : ''}`}
                    onClick={() => !disabled && onChange(option.value)}
                >
                    <div className={styles.radioOuter} style={{ borderColor: option.color }}>
                        <div
                            className={styles.radioInner}
                            style={{
                                backgroundColor:
                                    selected === option.value ? option.color : 'transparent',
                            }}
                        />
                    </div>
                    <div className={styles.listContent}>
                        <div className={styles.listTitle}>
                            {option.icon && <span className={styles.listIcon}>{option.icon}</span>}
                            <span>{option.label}</span>
                        </div>
                        {option.description && (
                            <div className={styles.listDescription}>{option.description}</div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ListSelect;
